import { useEffect, useState } from "react";
import chroma from "chroma-js"
import { useForm } from "react-hook-form";
import { AssistanceTagScreen } from "../../screen/AssistanceTagScreen";
import { useAssistanceTags } from "../../core/utils/hooks/useTags";
import { useScope } from "../SelectProjectCompanyContainer";
import Send from "../../core/communication";
import { customToast } from "../../components/Toast";
import { useSelector } from "react-redux";

export const AssistanceTagContainer = ({ selectedAssistance, setReload }) => {
  const { scope } = useScope();
  const user = useSelector(state => state?.app?.user?.user);
  const { tags, setReloadTags } = useAssistanceTags();

  const [tagId, setTagId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("")
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedTag, setSelectedTag] = useState([]);
  const [tagColor, setTagColor] = useState({
    tagBG: chroma("#2196f3").brighten(3).hex(),
    tagTextColor: "#2196f3",
  })

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { isValid, errors },
  } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    if(modalIsOpen){
      setReloadTags(true);
    } else {
      setTagId(null);
      setSearchTerm('');
      setSelectedTag([]);
    }
  }, [modalIsOpen])

  const filteredTags  = () => {
    if(searchTerm && tags.length) {
      return tags.filter(row => row.name.toLowerCase() === searchTerm.toLowerCase());
    }
    return tags || [];
  }

  const handleSearchTags = (e) => {
    setSearchTerm(e.target.value)
    reset({ keepErrors: false })
  }

  const handleOpenModal = () => {
    setModalIsOpen(true);
  }

  const handleCloseModal = () => {
    setModalIsOpen(false);
  }

  const handleRemoveTag = async (id) => {
    setLoading(true);

    try {
      await Send.delete(`/tags-assistance/${id}`)
      setReloadTags(true);
      setReload(true);
    } catch(error) {
      console.log("Erro ao remover tag", error);
      customToast('Erro ao remover tag', 'error');
    }

    setLoading(false);
  }

  const handleUpdateTag = async (data) => {
    const { name } = data;
    
    try {
      setLoading(true);
      await Send.put(`/tags-assistance/${tagId}`, {
        name,
        color: tagColor.tagBG,
        text_color: tagColor.tagTextColor,
      });
      setReloadTags(true);
      setReload(true);
    } catch (error) {
      console.log("Erro ao alterar tag(s)", error);
      customToast("Erro ao alterar tag(s)", "error");
    } finally {
      setLoading(false);
      setReloadTags(false);
      setReload(false);
    }
  
    setTagId("");
    setSelectedTag([]);
  };

  const handleEditTag = (value) => {
    setValue("name", value.name)
    setModalIsOpen(true)
    setTagId(value.id)
    setTagColor({
      tagBG: value?.color,
      tagTextColor: value?.text_color,
    })
  }

  const handleLinkTag = async () => {
    setLoading(true)
    const filteredTags = tags?.filter((item) => selectedTag.indexOf(item.id) !== -1);

    try {
      if(filteredTags.length > 0){
        const response = await Send.post("/tags-assistance-link", {
          userId: user?.id,
          tags: filteredTags,
          assistances: selectedAssistance
        });

        console.log(response)

        setModalIsOpen(false);
      }
    } catch(error) {
      console.log("Erro ao vincular tag(s)", error);
      customToast("Erro ao vincular tag(s)", "error");
    }
    finally {
      setReloadTags(true)
      setReload(true);
    }
    
    setLoading(false)
  }

  const dataTags = filteredTags() || []

  const handleCreateTag = async () => {
    if (searchTerm !== "") {
      setLoading(true)
      await Send.post("/tags-assistance", {
        name: searchTerm,
        color: chroma("#2196f3").brighten(2.5).hex(),
        text_color: "#2196f3",
        projectId: scope?.id,
      })
      setLoading(false);
    }
    setReloadTags(true);
    setSearchTerm("");
  }

  const handleChangeColor = (color) => {
    setTagColor({
      tagBG: chroma(color.hex).brighten(2.5).hex(),
      tagTextColor: color.hex,
    })
  }

  const handleSelectedTag = (e) => {
    const { checked, value } = e.target
    setSelectedTag((prev) => (checked ? [...prev, value] : prev.filter((val) => val !== value)))
  }

  const handleSelectedTagAll = (e) => {
    setSelectedTag(
      e.target.checked ? dataTags?.map((tags) => tags.id) : []
    )
  };

  return <AssistanceTagScreen
    {...{
      tagId,
      handleOpenModal,
      handleCloseModal,
      modalIsOpen,
      handleRemoveTag,
      handleEditTag,
      handleLinkTag,
      register,
      isValid,
      errors,
      handleSearchTags,
      searchTerm,
      handleCreateTag,
      handleChangeColor,
      handleSelectedTag,
      handleSelectedTagAll,
      selectedTag,
      selectedAssistance,
      loading,
    }}
    data={dataTags}
    handleSubmit={handleSubmit(handleUpdateTag)}
    selectedColor={tagColor}
  
  />
}
